/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Flex_Hint_SomeInputs */

const en_us2_profile_editors_flex_hint_some = /** @type {(inputs: Profile_Editors_Flex_Hint_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You fit them into the week`)
};

const pt_br2_profile_editors_flex_hint_some = /** @type {(inputs: Profile_Editors_Flex_Hint_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você encaixa na semana`)
};

const es_419_profile_editors_flex_hint_some = /** @type {(inputs: Profile_Editors_Flex_Hint_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los acomodas en la semana`)
};

const pt_pt2_profile_editors_flex_hint_some = /** @type {(inputs: Profile_Editors_Flex_Hint_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encaixa-los na semana`)
};

const fr_fr2_profile_editors_flex_hint_some = /** @type {(inputs: Profile_Editors_Flex_Hint_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu les places dans la semaine`)
};

const de_de2_profile_editors_flex_hint_some = /** @type {(inputs: Profile_Editors_Flex_Hint_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du verteilst sie über die Woche`)
};

const it_it2_profile_editors_flex_hint_some = /** @type {(inputs: Profile_Editors_Flex_Hint_SomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Li incastri nella settimana`)
};

/**
* | output |
* | --- |
* | "You fit them into the week" |
*
* @param {Profile_Editors_Flex_Hint_SomeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_flex_hint_some = /** @type {((inputs?: Profile_Editors_Flex_Hint_SomeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Flex_Hint_SomeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_flex_hint_some(inputs)
	if (locale === "es-419") return es_419_profile_editors_flex_hint_some(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_flex_hint_some(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_flex_hint_some(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_flex_hint_some(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_flex_hint_some(inputs)
	return en_us2_profile_editors_flex_hint_some(inputs)
});
export { profile_editors_flex_hint_some as "profile-editors.flex_hint_some" }